import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LegendItem from "crqlar-react-common/dist/components/availability/LegendItem";
import {CommonThemeColors} from "crqlar-react-common/dist/components/theme";
import {useTranslation} from "react-i18next";
import {RightSidebarFloatingPanel} from "../../layout/rightSidebar/RightSidebarFloatingPanel";
import {RightSidebarPanelHeader} from "../../layout/rightSidebar/RightSidebarPanelHeader";
import {RightSidebarPanelButton} from "../../layout/rightSidebar/RightSidebarRail";

export function ReservationCalendarLegendButton() {
    const {t} = useTranslation();

    return (
        <RightSidebarPanelButton
            icon={<InfoOutlinedIcon/>}
            label={t("Information")}
            renderPanel={close => (
                <RightSidebarFloatingPanel>
                    <RightSidebarPanelHeader title={t("Information")} onClose={close}/>
                    <Stack gap={2} sx={{px: 2, pb: 2}}>
                        <Typography variant="body2" color="text.secondary">
                            {t("Legend for availability colors")}
                        </Typography>
                        <Stack direction="row" justifyContent="space-between" gap={2}>
                            <LegendItem
                                color={CommonThemeColors.sys.availability.lightBlue}
                                label={t("Availability")}
                            />
                            <LegendItem
                                color={CommonThemeColors.sys.availability.lightRed}
                                label={t("Block")}
                            />
                        </Stack>
                    </Stack>
                </RightSidebarFloatingPanel>
            )}
        />
    );
}
